import { Search } from '@mui/icons-material';
import {
	Paper,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	TableRow
} from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import BenchmarkDrillSubmissionsItem from './BenchmarkDrillSubmissionsItem';
import { Placeholder, SortableTableHeader } from 'components';
import SearchForm from 'components/Search';
import { useBenchmarkSubmissions, useNavigation } from 'hooks';

const TABLE_HEADERS = [
	{
		value: 'image_url',
		label: 'Image',
		sortable: false,
		hidden: false
	},
	{
		value: 'status',
		label: 'Status',
		sortable: false,
		hidden: false
	},
	{
		value: 'user',
		label: 'User',
		sortable: false,
		hidden: false
	},
	{
		value: 'submitted_at',
		label: 'Submitted On',
		sortable: false,
		hidden: false
	}
];

export default function BenchmarkDrillSubmissionPendingList() {
	const { findBenchmarkSubmissions, benchmarkSubmissions, isLoading, isEmpty } =
		useBenchmarkSubmissions();
	const navigate = useNavigate();
	const { handleClick, handleEditClick, handleAddClick } = useNavigation({
		url: '/benchmark-submissions'
	});

	const handleSubmission = (submission) => {
		navigate(`/benchmark-submissions/${submission.id}/feedback`);
	};

	useEffect(() => {
		findBenchmarkSubmissions({
			status: 'pending'
		});
	}, []);

	return (
		<>
			<Paper>
				<SearchForm isLoading={false} query={''} handleSearch={() => {}} />
			</Paper>
			{benchmarkSubmissions?.length > 0 ? (
				<TableContainer component={Paper} elevation={0}>
					<Table>
						<TableHead>
							<TableRow>
								{TABLE_HEADERS.filter((h) => !h.hidden).map((header, idx) => (
									<SortableTableHeader
										key={idx}
										handleSort={() => {}}
										value={`benchmark-submission.${header.value}`}
										sortable={header.sortable}
										sortKey={''}
										sortDirection={''}
									>
										{header.label}
									</SortableTableHeader>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{benchmarkSubmissions.map((submission) => (
								<BenchmarkDrillSubmissionsItem
									submission={submission}
									handleClick={handleSubmission}
								/>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			) : (
				<Placeholder
					icon={<Search />}
					title="No Submissions"
					subtitle="Please try another search"
				/>
			)}
		</>
	);
}
